(ns ycweb.app.dashboard.planning.planning
  (:require
   #?@(:cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]
        [ycweb.components.tables :as tables]])
   [cemerick.url :as url]
   [clojure.set :as set]
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.dashboard.planning-css :as planning-css]
   [ycweb.app.dashboard.planning.common :as planning.cmn]
   [ycweb.app.dashboard.planning.planqtydifference]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(defn selection-filter-fn [app-atom]
  (let [{:keys [cat2 supplierid]} (cmn/screen-params app-atom)]
    (fn [plan-item]
      (cond
        (url/url-decode cat2)
        (= (second (:cats plan-item)) (url/url-decode cat2))

        :else
        (= (:supplier_id plan-item) (int supplierid))))))

(defn filter-items-to-selection [app-atom plan-items]
  (filter
    (selection-filter-fn app-atom)
    plan-items))

(defmethod comms/receive :stockorder.planning.planitem/broadcast-status [app-atom {:keys [data]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :items
      (fn [plan-items]
        (reduce
          (fn [data {:keys [vid status]}]
            (assoc-in data [vid :status] status))
          plan-items data)))))

(defmethod comms/receive :stockorder.planning.planitem/broadcast-qty [app-atom {:keys [data]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :items
      (fn [plan-items]
        (reduce
          (fn [data {:keys [vid qty]}]
            (assoc-in data [vid :qty] qty))
          plan-items data)))))

(defn update-mov-moq-atom [app-atom]
  (let [{:keys [items suppliers]} @(cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        selected-items
        (filter-items-to-selection app-atom (vals items))
        idx-suppliers (yuc/index-by :id suppliers)

        supplier-qty-val
        (reduce
          (fn [acc item]
            (update acc (:supplier_id item)
              (fn [supplier]
                {:qty (+ (:qty item) (or (:qty supplier) 0))
                 :value (+ (trf/fromcurrency (* (:qty item) (:cost item))) (or (:value supplier) 0))})))
          {}
          (filter
            #(and
               (not= "Ordered" (:status %))
               (> (:totalcost %) 0))
            selected-items))

        suppliers-below-mov-moq
        (->>
          supplier-qty-val
          (map
            (fn [[k v]]
              (let [supplier (get idx-suppliers k)
                    mov (:minordervalue supplier)
                    moq (:minorderqty supplier)]
                {:supplier_id k
                 ;; The drill-down links on supplier *plan* id, not supplier id.
                 :sps_id (:sps_id supplier)
                 :suppliername (:companyname supplier)
                 :qty (:qty v)
                 :val (:value v)
                 :mov (trf/tonumber mov)
                 :moq (planning.cmn/moq-number moq)})))
          (remove
            #(and
               (>= (:val %) (:mov %))
               (>= (:qty %) (:moq %)))))]

    (swap! action-atom
      assoc
      :suppliers-below-mov-moq
      (yuc/index-by :supplier_id suppliers-below-mov-moq))))

(defmethod grid/action :admin.planning-new/category [app-atom config _]
  (let [{:keys [cat1 cat2 supplierid]} config

        action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)
        selected-cat-atom (rum/cursor action-atom :selected-category-path)
        vid-histories (rum/cursor action-atom :vid-histories)
        plan-items @(rum/cursor-in process-atom [:items])

        selected-items (filter-items-to-selection app-atom (vals plan-items))

        pending-history-vids
        (set/difference
          (set (map :vid selected-items))
          (set (keys @vid-histories)))]

    (grid/dispatch-action app-atom :stockorder.planning/load-histories {:vids pending-history-vids})
    (grid/dispatch-action app-atom :stockorder.planning/load-future-quantities {:vids pending-history-vids})
    (grid/dispatch-action app-atom :stockorder.planning/load-missing-items {})

    (update-mov-moq-atom app-atom)
    (reset! selected-cat-atom config)))

(def suppliers-below-mov-moq-table-fns
  {:column-fns
   {:company-name-fn
    (fn [_ row _]
      [:div.item-name-status.clearfix
       [:span.companyname
        [:a.highslide
         {:href
          (str "planning.htm?action=plansupplier&supplierplanid="
            (:sps_id row))}
         (str (:suppliername row))]]])}})

(def suppliers-below-mov-moq-table-config
  {:table-name :stockorder.planning/suppliers-below-mov-moq
   :row-id :id
   :data-source {:cursor [:admin.planning-new/category :suppliers-below-mov-moq]}
   :column-defs
   [{:key :suppliername :title "Company Name" :type :text :default "N/A"
     :render {:render-k :company-name-fn}}
    {:key :mov :title "Minimum Order Value" :type :text :default "N/A"}
    {:key :val :title "Order Value" :type :text :default "N/A"}
    {:key :moq :title "Minimum Order Quantity" :type :text :default "N/A"}
    {:key :qty :title "Order Quantity" :type :text :default "N/A"}]})

(def out-of-stock-selected-items-table-fns
  {:config-fns
   {:filter-rows
    (fn [app-atom out-of-stock-plan-items]
      (filter
        (selection-filter-fn app-atom)
        out-of-stock-plan-items))}})

(def out-of-stock-selected-items-table-config
  {:table-name :stockorder.planning/out-of-stock-selected-items
   :row-id :id
   :data-source {:cursor [:admin.planning-new :out-of-stock-plan-items]}
   :options
   {:order :desc
    :filter :filter-rows}
   :column-defs
   [{:key :content_name :title "Product" :type :text :default "N/A"}
    {:key :variation_name :title "Variation Name" :type :text :default "N/A"}
    {:key :dateexpected :title "Expected Date" :type :date :default "N/A"}]})

(def overstock-items-table-config
  {:table-name :stockorder.planning/overstock-items
   :row-id :id
   :data-source {:cursor [:admin.planning-new :overstock-items]}
   :options
   {:order :desc}
   :column-defs
   [{:key :content_name :title "Product" :type :text :default "N/A"}
    {:key :variation_name :title "Variation Name" :type :text :default "N/A"}
    {:key :quantity :title "Quantity" :type :date :default "N/A"}]})

(rum/defcs root < (cmn/local {} ::local) rum/reactive [s app-atom]
  (let [local-atom (::local s)]
    [:div
     [:h1 "Checkboxes:"]
     [:p "Raw - change count: " (cmn/curact local-atom [:checkbox-raw-count])]

     [:label.checkbox-label
      (forms/checkbox-raw
        (rum/cursor local-atom :checkbox-raw)
        {:change-fn #(swap! local-atom update :checkbox-raw-count (fnil inc 0))})
      [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]]

     [:p "Field - change count: " (cmn/curact local-atom [:checkbox-field-count])]
     (forms/checkbox "Field checkbox"
       (rum/cursor local-atom :checkbox)
       {:change-fn #(swap! local-atom update :checkbox-field-count (fnil inc 0))})]))

(defn calculate-stock-turn [three-months-sales-by-vid category-items]
  (let [total-cost-of-stock-sold
        (reduce
          (fn [acc item]
            (+ acc (* (:qty item) (:costprice item))))
          0
          (flatten
            (vals three-months-sales-by-vid)))

        annualised-cost-of-stock
        (* (/ total-cost-of-stock-sold 3) 12)

        stock-value-on-hand-value
        (reduce
          (fn [acc item]
            ;; :cost is cents (cv.costprice * 100) while the sales numerator above
            ;; sums :costprice in rands — divide so both sides are rands.
            (+ acc
              (*
                (+ (or (:freestock item) 0) (or (:nonpickingstock item) 0))
                (/ (:cost item) 100))))
          0
          category-items)]

    (cond
      (zero? stock-value-on-hand-value)
      "N/A"

      :else
      (/ annualised-cost-of-stock stock-value-on-hand-value))))

(defn format-stock-turn [stock-turn]
  (if (number? stock-turn)
    (yuc/number-format stock-turn 2)
    (or stock-turn "N/A")))

(rum/defcs category-overview-cards <
  (cmn/local {:out-of-stock-show? false :overstock-show? false :sups-below-mov-moq-show? false} ::local) rum/reactive [s app-atom]
  (let [local-atom (::local s)
        action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)

        oos-show? (cmn/curact local-atom :out-of-stock-show?)
        overstock-show? (cmn/curact local-atom :overstock-show?)
        sups-below-mov-moq-show? (cmn/curact local-atom :sups-below-mov-moq-show?)

        selected-plan (cmn/curact process-atom [:selected-plan])
        ;; The dashboard row: it carries :plantype, which the raw stock_plan row
        ;; in :selected-plan does not (its column is `type`).
        plan-summary (cmn/curact process-atom [:plan-summary])
        idx-plan-items (cmn/curact process-atom :items)

        out-of-stock-plan-items (cmn/curact process-atom [:out-of-stock-plan-items])
        out-of-stock-selected-items
        (filter
          (selection-filter-fn app-atom)
          (vals out-of-stock-plan-items))

        three-months-sales-by-vid (cmn/curact process-atom :three-months-sales-by-vid)
        three-months-sales-by-vid-pre-status-change (cmn/curact process-atom :three-months-sales-by-vid-pre-status-change)
        plan-items (vals idx-plan-items)
        selected-items (filter (selection-filter-fn app-atom) plan-items)
        ready-plan-item-vids-pre-status-change (cmn/curact process-atom :ready-plan-item-vids-pre-status-change)

        ready-selected-plan-items-pre-status-change
        (map
          (fn [vid]
            (let [selected-item (get (yuc/index-by :vid selected-items) vid)]
              {:vid (:vid selected-item)
               :freestock (:freestock selected-item)
               :nonpickingstock (:nonpickingstock selected-item)
               :cost (:cost selected-item)
               :status (:status selected-item)}))
          ready-plan-item-vids-pre-status-change)

        stock-turn-before-ready
        (calculate-stock-turn
          three-months-sales-by-vid-pre-status-change
          ready-selected-plan-items-pre-status-change)

        stock-turn-ready
        (calculate-stock-turn
          three-months-sales-by-vid
          (filter #(= (:status %) "Ready")
            (map
              (fn [item]
                {:freestock (:freestock item)
                 :nonpickingstock (:nonpickingstock item)
                 :cost (:cost item)
                 :status (:status item)})
              selected-items)))]

    [:div
     {:class (yuc/bem :flex-grid-group [:flush])}
     [:div
      {:class (yuc/bem :flex-grid-block [:l-1-3])}
      [:div.flex-grid-content.stats-table-card
       (headings/heading "Category Details"
         {:type :h3
          :size :small})
       [:table.stats-table
        [:tbody
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Suppliers:"]]
          [:td.stats-table__td.u-text-right (count (distinct (map :supplier_id selected-items)))]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Brands:"]]
          [:td.stats-table__td.u-text-right (count (distinct (map :brandrootid selected-items)))]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Products:"]]
          [:td.stats-table__td.u-text-right (count (distinct (map :contentid selected-items)))]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Variations:"]]
          [:td.stats-table__td.u-text-right (count (distinct (map :vid selected-items)))]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Plan Filter:"]]
          [:td.stats-table__td.u-text-right (:filter selected-plan)]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Plan Type:"]]
          ;; :selected-plan is the raw stock_plan row, whose column is `type`.
          ;; query-plans aliases it, so plan-summary is what carries :plantype.
          [:td.stats-table__td.u-text-right (:plantype plan-summary)]]]]]]
     [:div
      {:class (yuc/bem :flex-grid-block [:l-1-3])}
      [:div.flex-grid-content.stats-table-card
       (headings/heading "Supplier Plan Details"
         {:type :h3
          :size :small})
       [:table.stats-table
        [:tbody
         [:tr.stats-table__row
          [:th.stats-table__th
           {:on-click
            #(swap! local-atom assoc :sups-below-mov-moq-show? (not sups-below-mov-moq-show?))}
           [:b (str "Supplier without MOV/MOQ reached: " (count (cmn/curact action-atom :suppliers-below-mov-moq)))]
           [:i
            {:class
             (yuc/bem :icon [(if sups-below-mov-moq-show? :chevron-down :chevron-right) :inline])}]]]]]]]
     [:div
      {:class (yuc/bem :flex-grid-block [:l-1-3])}
      [:div.flex-grid-content.stats-table-card
       (headings/heading "Category Plan Details"
         {:type :h3
          :size :small
          :subtext "Inc. 'Not Ready' items"})
       [:table.stats-table
        [:tbody
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Stock Turn Before Any SKUs Are Marked Ready:"]]
          [:td#stockturnbeforeready.stats-table__td.u-text-right (format-stock-turn stock-turn-before-ready)]]
         [:tr.stats-table__row
          [:th.stats-table__th [:b "Stock Turn After SKUs Have Been Marked Ready:"]]
          [:td#stockturnready.stats-table__td.u-text-right (format-stock-turn stock-turn-ready)]]

         [:tr.stats-table__row
          [:th.stats-table__th
           [:b "SKUs in Overstock List: (COMING SOON TO A PLANNING TOOL NEAR YOU!)"]
           #_#_#_{:on-click
                  #(swap! local-atom assoc :overstock-show? (not overstock-show?))}
               [:b "SKUs in Overstock List: " (count overstock-items)]
             [:i
              {:class
               (yuc/bem :icon [(if overstock-show? :chevron-down :chevron-right) :inline])}]]]
         [:tr.stats-table__row
          [:th.stats-table__th
           {:on-click
            #(swap! local-atom assoc :out-of-stock-show? (not oos-show?))}
           [:b "OOS SKUs with ETA 2-3 weeks: " (count out-of-stock-selected-items)]
           [:i
            {:class
             (yuc/bem :icon [(if oos-show? :chevron-down :chevron-right) :inline])}]]]]]]]

     (when sups-below-mov-moq-show?
       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-1])}
        (datatables/table app-atom
          :stockorder.planning/suppliers-below-mov-moq
          suppliers-below-mov-moq-table-fns)])

     (when overstock-show?
       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-1])}
        (datatables/table app-atom :stockorder.planning/overstock-items {})])

     (when oos-show?
       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-1])}
        (datatables/table app-atom
          :stockorder.planning/out-of-stock-selected-items
          out-of-stock-selected-items-table-config)])]))

(defmethod grid/action :stockorder.planning/toggle-product-type [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        product-types-atom (rum/cursor-in action-atom [:product-types])
        existing-product-types (set @product-types-atom)
        clicked-type (:product-type config)
        new-product-types
        (if (contains? existing-product-types clicked-type)
          (set/difference existing-product-types (set [clicked-type]))
          (set/union existing-product-types (set [clicked-type])))]
    (reset! product-types-atom new-product-types)))

(defmethod grid/action :stockorder.planning/toggle-brand [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        brands-atom (rum/cursor-in action-atom [:brands])
        existing-brands (set @brands-atom)
        clicked-brand (:brand config)
        new-brands
        (if (contains? existing-brands clicked-brand)
          (set/difference existing-brands (set [clicked-brand]))
          (set/union existing-brands (set [clicked-brand])))]
    (reset! brands-atom new-brands)))

(rum/defc product-history-row [current-date dates title history data-key]
  #?(:cljs
     (into
       [:tr
        [:td title]]
       (map
         (fn [[year month]]
           [:td
            {:style
             (when
               (and
                 (= month (str/format "%02d" (dt/month current-date)))
                 (= year (str (dt/year current-date))))
               {:background-color "#00bbff"})}
            (get-in history [year month data-key])])
         dates))))

(rum/defc product-history < rum/reactive [app-atom history]
  #?(:cljs
     (let [current-date (dt/now)
           start (dt/first-day-of-the-month (dt/minus current-date (dt/years 1)))
           history-date-seq
           (map
             (fn [x]
               (let
                 [current (dt/plus start (dt/months x))]
                 [(str (dt/year current)) (str/format "%02d" (dt/month current))]))
             (range 13))

           seeded-row (partial product-history-row current-date history-date-seq)]
       [:div.u-relative
        [:table.oTable
         [:thead
          (into
            [:tr
             [:th]]
            (map
              (fn [[year month]]
                [:th
                 {:style
                  (when
                    (and
                      (= month (str/format "%02d" (dt/month current-date)))
                      (= year (str (dt/year current-date))))
                    {:background-color "#00bbff"})}
                 year [:br] month]) history-date-seq))]
         [:tbody
          (seeded-row
            "Online Sales" history :onlineunits)

          (seeded-row
            "Store Sales" history :storeunits)

          (seeded-row
            "Sellable" history :sellablepercofmonth)

          (seeded-row
            "Manual Forecast" history :forecast)

          (seeded-row
            "Stock Orders" history :units)]]
        (toaster/loading-overlay app-atom :stockorder.planning/history)])))

(rum/defc quantities-on-order < rum/reactive [app-atom history]
  #?(:cljs
     (let [current-date (dt/now)
           start (dt/first-day-of-the-month current-date)
           history-date-seq
           (map
             (fn [x]
               (let
                 [current (dt/plus start (dt/months x))]
                 [(str (dt/year current)) (str/format "%02d" (dt/month current))]))
             (range 7))

           seeded-row (partial product-history-row current-date history-date-seq)]

       [:div.u-relative
        [:table.oTable
         [:thead
          (into
            [:tr
             [:th]]
            (map
              (fn [[year month]]
                [:th
                 {:style
                  (when
                    (and
                      (= month (str/format "%02d" (dt/month current-date)))
                      (= year (str (dt/year current-date))))
                    {:background-color "#00bbff"})}
                 year [:br] month])
              history-date-seq))]
         [:tbody
          (seeded-row
            "On Order" history :units)]]
        (toaster/loading-overlay app-atom :stockorder.planning/history)])))

(rum/defc split-order-toggle < rum/reactive [app-atom brand-name brand-items]
  (let [{:keys [brandplanid splitorder]} (first brand-items)
        checkbox-id (str "split-order-" brandplanid)]
    [:div {:style {:flex-shrink 0 :margin-top "8px"}}
     [:label
      {:for checkbox-id
       :class (yuc/bem :checkbox-label [:inline])
       :on-click #(.stopPropagation %)}
      [:input.checkbox
       {:id checkbox-id
        :type "checkbox"
        :checked (boolean (yuc/as-bool splitorder))
        :on-click #(.stopPropagation %)
        :on-change
        (fn [e]
          (.stopPropagation e)
          (grid/dispatch-action app-atom :stockorder.planning/toggle-split-order
            {:brandplan-id brandplanid
             :brand-name brand-name
             :split-order? (not (yuc/as-bool splitorder))}))}]
      [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
      [:span.checkbox__text "Split Order"]]]))

(rum/defc commitment-order-toggle < rum/reactive [app-atom {:keys [id period committedqty status]}]
  (let [checkbox-id (str "commitment-order-" id)]
    [:label
     {:for checkbox-id
      :class (yuc/bem :checkbox-label [:inline])}
     [:input.checkbox
      {:id checkbox-id
       :type "checkbox"
       :checked (= status "Ready")
       :on-change
       (fn [_]
         (grid/dispatch-action app-atom :stockorder.planning/toggle-commitment-order
           {:commitment-id id
            :include? (not= status "Ready")}))}]
     [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
     [:span.checkbox__text (str period ": " committedqty)]]))

(rum/defc brand-cards < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        plan-items-atom (rum/cursor-in process-atom [:items])
        plan-items (vals (rum/react plan-items-atom))
        selected-brands (cmn/curact action-atom [:brands])
        selected-items (filter (selection-filter-fn app-atom) plan-items)
        selected-items-by-brands (group-by :brand selected-items)
        supplier-view? (yuc/presence (:supplierid (cmn/screen-params app-atom)))]
    (into
      [:div
       {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}]
      (map
        (fn [x]
          [:div
           {:class (yuc/bem :flex-grid-block [:ml-1-3 :l-1-5 :xl-1-6])}
           [:button.flex-grid-content
            {:type "button"
             :on-click
             #(grid/dispatch-action app-atom :stockorder.planning/toggle-brand
                {:brand x})
             :class (yuc/bem :admin-prodtype-card [(when (contains? selected-brands x) :is-active)])}
            [:h3.admin-prodtype-card__title (or x "-- None --")]
            [:ul.admin-prodtype-card__meta
             [:li.admin-prodtype-card__qty
              "Available Variations: "
              (count (get selected-items-by-brands x))]
             [:li.admin-prodtype-card__val
              [:span.u-hidden-from-view "Value:"]
              (str "R"
                (yuc/currency-format
                  (reduce
                    #(+ %1 (:totalcost %2))
                    0
                    (get selected-items-by-brands x))
                  2))]]
            (when supplier-view?
              (split-order-toggle app-atom x (get selected-items-by-brands x)))
            [:div.admin-prodtype-card__indicator
             [:i.icon.icon--block.icon--default.icon--is-light.icon--small.icon--check]]]])
        (keys selected-items-by-brands)))))

(rum/defc product-type-cards < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        plan-items-atom (rum/cursor-in process-atom [:items])
        plan-items (vals (rum/react plan-items-atom))
        selected-product-types (cmn/curact action-atom [:product-types])
        selected-items (filter (selection-filter-fn app-atom) plan-items)
        selected-items-by-producttype (group-by :producttype selected-items)]
    (into
      [:div
       {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}]
      (map
        (fn [x]
          [:div
           {:class (yuc/bem :flex-grid-block [:ml-1-3 :l-1-5 :xl-1-6])}
           [:a.flex-grid-content
            {:on-click
             #(grid/dispatch-action app-atom :stockorder.planning/toggle-product-type
                {:product-type x})
             :class (yuc/bem :admin-prodtype-card [(when (contains? selected-product-types x) :is-active)])
             :type "statusupdate" :status "Ready"}
            [:h3.admin-prodtype-card__title (or x "-- None --")]
            [:ul.admin-prodtype-card__meta
             [:li.admin-prodtype-card__qty
              "Q"
              [:span.u-hidden-from-view "uanti"]
              "ty: "
              (count (get selected-items-by-producttype x))]
             [:li.admin-prodtype-card__val
              [:span.u-hidden-from-view "Value:"]
              (str "R"
                (yuc/currency-format
                  (reduce
                    #(+ %1 (:totalcost %2))
                    0
                    (get selected-items-by-producttype x))
                  2))]]
            [:div.admin-prodtype-card__indicator
             [:i.icon.icon--block.icon--default.icon--is-light.icon--small.icon--check]]]])
        (keys selected-items-by-producttype)))))

(defmethod grid/action :stockorder.planning.planitem/update-status [app-atom stockitem _]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-plan-atom (rum/cursor-in process-atom [:selected-plan])]
    (comms/send :stockorder.planning.planitem/update-status (assoc stockitem :stockplanid (:id @selected-plan-atom)))))

(defmethod comms/receive :stockorder.planning.planitem/update-status
  [app-atom {:keys [success status vid itemid msg]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (cond
      (not success)
      (toaster/open-toast app-atom :error (or msg "Could not change the line's status.") {})

      :else
      (swap! process-atom
        (fn [process]
          (cond->
            (assoc-in process [:items vid :status] status)
            (= status "Ready")
            (update :grouped-entity-flags dissoc ["stock_plan_items" itemid])))))))

(rum/defc status-indicator < rum/reactive [{:keys [status total-items-not-ready]} click-fn]
  [:a
   {:on-click (when click-fn click-fn)
    :class
    (yuc/bem
      :admin-status-dot
      [:l
       (case status
         "Not Ready"
         :notready

         "Ready"
         :ready

         "Ordered"
         :ordered

         nil)
       (when
         (and total-items-not-ready (> total-items-not-ready 0))
         :notreadyitems)])}])

(defmethod grid/action :stockorder.planning.planitem/add [app-atom config _]
  (let [vid (:variation_id config)
        action-atom (cmn/action-cursor app-atom)
        missing-atom (rum/cursor-in action-atom [:missing])
        missing-items (cmn/curact missing-atom :items)
        missing-item (get missing-items vid)
        new-missing-items (dissoc missing-items vid)]
    (planning.cmn/show-loading! app-atom "Adding item")
    (swap! action-atom update-in [:missing]
      assoc
      :item missing-item
      :items new-missing-items)
    (comms/send :stockorder.planning.planitem/add config)))

(defmethod comms/receive :stockorder.planning.planitem/add [app-atom {:keys [_ error msg]}]
  (let [action-atom (cmn/action-cursor app-atom)
        missing-atom (rum/cursor-in action-atom [:missing])
        missing-items-atom (rum/cursor missing-atom :items)
        missing-items (vals @missing-items-atom)
        missing-item (cmn/curact missing-atom :item)
        new-missing-items (conj missing-items missing-item)]
    (planning.cmn/hide-loading! app-atom)
    (when error
      (toaster/open-toast app-atom :error msg {})
      (reset! missing-items-atom (yuc/index-by :variation_id new-missing-items)))))

(rum/defc missing-items-table < rum/reactive [app-atom]
  #?(:cljs
     (let [process-atom (cmn/process-cursor app-atom)
           selected-plan-atom (rum/cursor-in process-atom [:selected-plan])
           plan-filter (:filter @selected-plan-atom)
           action-atom (cmn/action-cursor app-atom)
           selected-product-types (set (cmn/curact action-atom :product-types))
           missing-atom (rum/cursor-in action-atom [:missing])
           missing-items (vals (cmn/curact missing-atom :items))
           missing-values (yuc/index-by :variation_id (cmn/curact missing-atom :values))

           product-type-filter-fn
           (fn [coll]
             (cond
               (not (empty? selected-product-types))
               (filter
                 #(contains? selected-product-types (:producttype %))
                 coll)

               :else coll))

           items-header
           [{:key :productadd :title "Add"
             :component-fn
             (fn [_ row]
               [:span.text-link
                {:on-click
                 #(grid/dispatch-action app-atom :stockorder.planning.planitem/add
                    {:planid (:id @selected-plan-atom)
                     :supplier_id (:supplier_id row)
                     :brandrootid (:brandrootid row)
                     :variation_id (:variation_id row)})}
                "Add item"])}
            {:key :contentlive_text :title "Status"}
            {:key :productname :title "Product"
             :style {:white-space "nowrap"}}
            {:key :variationname :title "Variation"}
            {:key :seasonal :title "Seasonal"}
            {:key :cost-price :title "Cost" :align-class :u-text-right}
            {:key :stock :title "Stock" :type :number}
            {:key :freestock :title "Freestock" :type :number}
            {:key :ringfenced :title "Ringfenced" :type :number}
            {:key :nonpickingstock_adjusted :title "NPS (excl stores)" :type :number}
            {:key :plan-qty-store :title "Store Plan" :type :number}
            {:key :allocated-store :title "Store Allocated" :type :number}
            {:key :onorder :title "On Order" :type :number}
            {:key :registrypaid :title "Paid Registries" :type :number}
            {:key :supplierstock :title "Supplier SOH" :type :number}
            {:key :essentialgood :title "Lockdown Level" :type :number}
            {:key :secondbest15days :title "Second best 15 days" :type :number}
            {:key :sevendays :title "7 Day Sales" :type :number}
            {:key :twentyeightdays :title "28 Day Sales" :type :number}]

           selected-items
           (->>
             missing-items
             (product-type-filter-fn)
             ;;TODO Replace filter below with (filter-products (:type plan)) function
             (filter #(planning.cmn/filter-product-on-type plan-filter %))
             (map
               (fn [row]
                 (let [vid-values (get missing-values (:variation_id row))
                       sevendays
                       (cond
                         (>= (dtc/from-string (:date_placed vid-values)) (dt/minus (dt/today) (dt/days 7)))
                         (:stockqty vid-values)

                         :else
                         0)]
                   (assoc row
                     :cost-price (yuc/currency-format (:cost row) 2)
                     :nonpickingstock_adjusted (min (- (:nonpickingstock row) (:freestock_qty vid-values)) 0)
                     :allocated-store (:freestock_qty vid-values)
                     :neededstores (:neededstores vid-values)
                     :sevendays sevendays
                     :twentyeightdays (:stockqty vid-values)
                     :plan-qty-store (:plannedqty vid-values))))))]

       (tables/table "Missing SKU's"
         items-header
         selected-items
         {}))))

(def plan-items-table-fns
  {:config-fns
   {:filter-rows
    (fn [app-atom rows]
      (let [action-atom (cmn/action-cursor app-atom)
            process-atom (cmn/process-cursor app-atom)
            selected-product-types (set (cmn/curact action-atom :product-types))
            selected-brands (set (cmn/curact action-atom :brands))
            plan-items-atom (rum/cursor-in process-atom [:items])
            plan-items (vals (rum/react plan-items-atom))

            item-filter (selection-filter-fn app-atom)

            selected-items (filter item-filter plan-items)
            selected-item-producttypes (set (map :producttype selected-items))
            selected-item-brands (set (map :brand selected-items))]
        (filter
          #(and
             (item-filter %)
             (or
               (empty? (set/intersection selected-brands selected-item-brands))
               (contains? selected-brands (:brand %)))
             (or
               (empty? (set/intersection selected-product-types selected-item-producttypes))
               (contains? selected-product-types (:producttype %))))
          rows)))
    :row-class-fn
    (fn [app-atom row]
      (let [process-atom (cmn/process-cursor app-atom)
            grouped-entity-flags (cmn/curact process-atom :grouped-entity-flags)]
        (when (not (empty? (get grouped-entity-flags ["stock_plan_items" (:itemid row)])))
          (yuc/bem :row-status [:is-error]))))}
   :column-fns
   {:status-cell-fn
    (fn [row _]
      (when (not= (:contentlive row) 0)
        [:plan-warning]))
    :status-render-fn
    (fn [app-atom row col cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            grouped-entity-flags (cmn/curact process-atom :grouped-entity-flags)]
        (str
          (:contentlive_text row)
          " "
          (apply str
            (interpose ", "
              (map :reason (get grouped-entity-flags ["stock_plan_items" cell-val])))))))
    :ready-status-fn
    (fn [app-atom row col cell-val]
      [:div.u-text-center
       (status-indicator {:status cell-val}
         #(grid/dispatch-action app-atom :stockorder.planning.planitem/update-status {:stockplanitemid (:itemid row)}))])
    :product-name
    (fn [_ row _ _]
      (str (:productname row) " - " (:variationname row)
        (when (yuc/presence (:feature1 row)) (str " | " (:feature1 row)))
        (when (yuc/presence (:feature2 row)) (str " | " (:feature2 row)))))
    :product-fn
    (fn [_ row _ _]
      [:div.item-name-status.clearfix
       [:span.itemname
        [:a.highslide
         {:href
          (str "products_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]="
            (:contentid row))}
         (str (:productname row) " - " (:variationname row))]
        (str
          (when (yuc/presence (:feature1 row)) (str " | " (:feature1 row))))
        (str
          (when (yuc/presence (:feature2 row)) (str " | " (:feature2 row))))]])
    :cost-fn
    (fn [_ row _ cell-val]
      (str (yuc/currency-format cell-val 2) "(" (:supplier_packsize row) ")"))
    :rsp-fn
    (fn [_ _ _ cell-val]
      (yuc/currency-format (* (or cell-val 0) 100) 2))
    :total-rsp-fn
    (fn [_ row _ cell-val]
      (yuc/currency-format (* (:qty row) (or cell-val 0) 100) 2))
    :total-cost-logic-fn (fn [_ _ _ cell-val] cell-val)
    :total-cost-render-fn (fn [_ row _ cell-val] (yuc/currency-format (* (:qty row) cell-val) 2))
    :store-plan-fn
    (fn [app-atom _ _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            store-plans (cmn/curact process-atom :store-plan-qtys)
            idx-store-plans (yuc/index-by :variation_id store-plans)
            {:keys [storeplanqty]} (get idx-store-plans cell-val)]
        (or storeplanqty 0)))
    :store-allocated-fn
    (fn [app-atom _ _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            allocated-stock (cmn/curact process-atom :allocated-stock)
            allocated-stock-by-vid (yuc/index-by :variation_id allocated-stock)
            {:keys [destinedqty]} (get allocated-stock-by-vid cell-val)]
        (or destinedqty 0)))
    ;; The legacy tool's nonpickingstock_adjusted, clamped at zero from above as
    ;; the missing items grid does: stores hold more non-picking stock than the
    ;; variation has, so the figure reads negative.
    :nps-excl-stores-fn
    (fn [app-atom row _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            allocated-stock-by-vid (yuc/index-by :variation_id (cmn/curact process-atom :allocated-stock))
            allocated (or (:destinedqty (get allocated-stock-by-vid (:vid row))) 0)]
        (min (- (or cell-val 0) allocated) 0)))
    :freestock-fn
    (fn [_ row _ cell-val]
      [:div.freestock.clearfix
       [:span.freestock
        [:a.highslide
         {:href (str "freestock.htm?variationid=" (:vid row))
          :target "_blank"}
         cell-val]]])
    :history-fn
    (fn [app-atom _ col cell-val]
      (let [action-atom (cmn/action-cursor app-atom)
            vid-histories (cmn/curact action-atom :vid-histories)]
        (product-history app-atom (get vid-histories cell-val))))
    :needed-stores-fn
    (fn [app-atom {:keys [vid productname variationname feature1 feature2]} col cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            store-plans (cmn/curact process-atom :store-plan-qtys)
            allocated-stock (cmn/curact process-atom :allocated-stock)
            allocated-stock-by-vid (yuc/index-by :variation_id allocated-stock)
            plan-id (cmn/curact process-atom :planid)
            store-need
            (yuc/index-by :variation_id
              (map
                (fn [x]
                  {:variation_id (:variation_id x)
                   :qty
                   (max
                     (-
                       (or (:storeplanqty x) 0)
                       (or
                         (:destinedqty (get allocated-stock-by-vid (:variation_id x)))
                         0))
                     0)})
                store-plans))]
        [:a
         (merge
           (urlstate/href-props app-atom "planning-new" "plan-qty-difference"
             {:plan-id plan-id
              :vid vid
              :product-name productname
              :variation-name variationname
              :feature1 feature1
              :feature2 feature2})
           {:target "_blank"})
         (or (:qty (get store-need vid)) 0)]))
    :sum-needed-yc-fn
    (fn [_ row col _]
      [:div
       [:a
        {:href
         (str "/admin/purchases.htm?action=listitems&overrideincludes=&variationid="
           (:vid row)
           "&contentid=&vouchercode=&datefilter=dateplaced&datefrom=&dateto=&status%5B2%5D=yes&id=&userid=&searchstr=")
         :target "_blank"}
        (:needed row)]])
    :needed-yc-fn
    (fn [app-atom _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            store-plans (cmn/curact process-atom :yc-orders)]
        (map
          (fn [x]
            [:div
             [:a
              (merge
                (urlstate/href-props app-atom "orders" ""
                  {"sm[order1][id]" (:orderid x)
                   :overrideincludes "popup"})
                {:target "_blank"})
              (str "YC" (:orderid x) " ")]])
          (get-in store-plans [cell-val]))))
    :qty-edit-fn (editor/edit-field :stockorder/plan-items :inline {:onblur-fn :submit :on-open :clear})
    :commitment-fn
    (fn [app-atom _ col cell-val]
      (let [action-atom (cmn/action-cursor app-atom)
            commitment-quantities (cmn/curact action-atom :commitment-quantities)]
        (quantities-on-order app-atom (get commitment-quantities cell-val))))
    ;; An explicit 0 rather than an empty cell, which reads as "not checked".
    :ringfenced-fn
    (fn [_ _ _ cell-val]
      (let [qty (or cell-val 0)]
        (if (pos? qty)
          [:b {:title "Held for an active ringfence policy — excluded from available stock"}
           qty]
          0)))

    :commitment-order-fn
    (fn [app-atom _ _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            commitments (get (cmn/curact process-atom :plan-commitments) cell-val)]
        (into [:div]
          (map
            (fn [commitment]
              (rum/with-key
                (commitment-order-toggle app-atom commitment)
                (:id commitment)))
            commitments))))
    :indent-fn
    (fn [app-atom _ col cell-val]
      (let [action-atom (cmn/action-cursor app-atom)
            indent-quantities (cmn/curact action-atom :indent-quantities)]
        (quantities-on-order app-atom (get indent-quantities cell-val))))
    :needed-stores-overstocked-fn
    (fn [app-atom _ _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            plan-and-stock-qtys (cmn/curact process-atom :store-stock-and-plan-qtys)]
        (get-in plan-and-stock-qtys [cell-val :overstocked])))
    :needed-stores-understocked-fn
    (fn [app-atom _ _ cell-val]
      (let [process-atom (cmn/process-cursor app-atom)
            plan-and-stock-qtys (cmn/curact process-atom :store-stock-and-plan-qtys)]
        (get-in plan-and-stock-qtys [cell-val :understocked])))}})

(def column-def-config
  [{:key :stockplan-item/itemid :title "Status" :type :string
    :cell-classes-k :status-cell-fn
    :render {:render-k :status-render-fn}}
   {:key :stockplan-item/status :title "Ready Status"
    :render {:render-k :ready-status-fn}}
   {:key :stockplan-item/productname :title "Product"
    :render {:render-k :product-fn}}
   {:key :stockplan-item/seasonal :title "Seasonal" :default "N/A"}
   {:key :stockplan-item/notavailable-text :title "Supplier Available" :type :string}
   {:key :stockplan-item/ETA :title "ETA" :type :string}
   {:key :stockplan-item/cost :title "Cost (Packsize)" :align-class :u-text-right
    :render
    {:render-k :cost-fn}}
   {:key :stockplan-item/price :title "RSP" :align-class :u-text-right
    :render {:render-k :rsp-fn}}
   {:key :stockplan-item/cost :title "Total Cost" :align-class :u-text-right
    :render
    {:logic-k :total-cost-logic-fn
     :render-k :total-cost-render-fn}}
   {:key :stockplan-item/price :title "Total RSP" :align-class :u-text-right
    :render {:render-k :total-rsp-fn}}
   {:key :stockplan-item/minimumstocklevel :title "Min. Level" :type :number}
   {:key :stockplan-item/nonpickingstock :title "NPS (excl stores)" :type :number
    :render {:logic-k :nps-excl-stores-fn}}
   {:key :stockplan-item/vid :title "Store Plan" :type :number
    :render {:logic-k :store-plan-fn}}
   {:key :stockplan-item/vid :title "Store Allocated" :type :number
    :render {:logic-k :store-allocated-fn}}
   #_{:key :store-ibt :title "Store IBT" :type :number}
   {:key :stockplan-item/freestock :title "Freestock" :align-class :u-text-right
     :render {:render-k :freestock-fn}}
   {:key :stockplan-item/availablestock :title "SOH ex. NPS" :align-class :u-text-right}
   {:key :stockplan-item/ringfenced :title "Ringfenced" :align-class :u-text-right
    :render {:render-k :ringfenced-fn}}
   {:key :stockplan-item/onorder :title "On Order" :type :number}
   {:key :stockplan-item/vid :title "Commitment"
    :default-hidden? true
    :render {:render-k :commitment-fn}}
   {:key :stockplan-item/itemid :title "Commitment Order"
    :default-hidden? true
    :render {:render-k :commitment-order-fn}}
   {:key :stockplan-item/vid :title "Indent"
    :default-hidden? true
    :render {:render-k :indent-fn}}
   #_{:key :waitingnotifications :title "Notify" :type :number}
   {:key :stockplan-item/supplierstock :title "Supplier SOH" :type :number}
   {:key :stockplan-item/vid :title "History"
    :render {:render-k :history-fn}}
   #_{:key :manual-forecast :title "Manual Forecast" :type :number}
   {:key :stockplan-item/registrypaid :title "Needed for Registries" :type :number}
   {:key :stockplan-item/needed :title "Needed for Customers" :type :number
    :render
    {:render-k :sum-needed-yc-fn}}
   {:key :vid :title "Needed for Stores" :type :number
    :render
    {:render-k :needed-stores-fn}}
   {:key :vid :title "Store overstocked" :type :number :default-hidden? true
    :render
    {:logic-k :needed-stores-overstocked-fn}}
   {:key :vid :title "Store understocked" :type :number :default-hidden? true
    :render
    {:logic-k :needed-stores-understocked-fn}}
   {:key :stockplan-item/forecastqty :title "Online Forecast Qty" :type :number}
   #_{:key :online-data-quality :title "Online Data Quality"}
   #_{:key :store-data-quality :title "Store Data Quality"}
   {:key :stockplan-item/qty :title "Order Qty" :type :number :cell-edit :qty-edit-fn}])

(def plan-items-table-config
  (let [original-column-defs
        (vec
          (map-indexed
            (fn [idx x]
              (assoc x :position idx))
            column-def-config))]
    {:table-name :stockorder/plan-items
     :row-id :vid
     :row-class-k :row-class-fn
     :data-source {:cursor [:admin.planning-new :items]}
     :options
     {:order :desc
      :filter :filter-rows
      :paging? false
      :sticky-header? true}
     :column-defs
     (remove :default-hidden? original-column-defs)
     :column-defs-headers original-column-defs}))

(def plan-items-editor-config
  {:editor-name :stockorder/plan-items
   :datatable :stockorder/plan-items
   :mode :read
   :end-points
   {:edit :stockorder.planning.planitem/update}
   :fields
   [{:name :stockplan-item/qty
     :label "Quantity:"
     :type :text
     :attr {:type :number}}
    {:name :stockplan-item/itemid
     :type :hidden}
    {:name :vid
     :type :hidden}]})

(defmethod comms/receive :stockorder.planning.planitem/update
  [app-atom {:keys [rows] :as submission-response}]
  (let [process-atom (cmn/process-cursor app-atom)
        status (editor/post-submit app-atom :stockorder/plan-items submission-response)
        {:keys [row-id]} plan-items-table-config]
    (when (:success status)
      (swap! process-atom update-in [:items]
        (fn [items]
          (reduce
            (fn [acc row]
              (update acc (get row row-id) assoc :editing? false))
            items rows))))))

(rum/defc action-item < rum/reactive
  [state-atom path
   {:keys [id title detail-body-fn default-foldout?]}]
  (let [foldout-state-atom (rum/cursor-in state-atom path)
        foldout (or (rum/react foldout-state-atom) #{(when default-foldout? id)})
        toggle-fold
        (fn [n open?]
          (swap! foldout-state-atom (fnil (if open? conj disj) #{}) n))
        opened? (contains? foldout id)]

    [:section.admin-action-item
     [:header.admin-action-item__header
      [:span
       (cond
         opened?
         [:a.admin-action-item__link
          {:style
           {:cursor "pointer"}
           :on-click
           (fn []
             (toggle-fold id false))}
          [:i {:class (yuc/bem :icon [:is-dark :minus :block])}]]

         :else
         [:a.admin-action-item__link
          {:style
           {:cursor "pointer"}
           :on-click
           (fn []
             (toggle-fold id true))}
          [:i {:class (yuc/bem :icon [:is-dark :plus :block])}]])]
      [:h2.admin-action-item__title title]]

     (when (and opened? detail-body-fn)
       (into [:div.admin-action-item__content]
         (if (seq? detail-body-fn) detail-body-fn [detail-body-fn])))]))

(rum/defc action-section [{:keys [title items]}]
  (into
    [:section.admin-action-list
     [:h2.admin-action-list__section-title title]]
    (remove nil? items)))

(rum/defc hideable-data-table-columns < rum/reactive
  [state-atom path checkbox-path header-list]
  (print (cmn/curact state-atom path))
  [:<>
   [:div
    [:form
     (into
       [:div {:class (yuc/bem :flex-grid-group [:align-left :flush])}]
       (map
         (fn [header-lists]
           [:div
            {:class (yuc/bem :flex-grid-block [:fluid])}
            (into
              [:div.flex-grid-content]
              (map
                (fn [[indx {:keys [title default-hidden?] :as header}]]
                  [:div.form-field
                   (forms/checkbox
                     title
                     (rum/cursor state-atom (conj checkbox-path indx))
                     {:default-checked (not default-hidden?)
                      :yc-input? true
                      :pre-change-fn
                      (fn [_]
                        (let [toggle-titles (yuc/index-by :position (cmn/curact state-atom path))
                              hidden-default-map (when default-hidden? (assoc header :default-hidden? false))]
                          (swap! state-atom assoc-in path
                            (->>
                              (cond
                                (get toggle-titles indx)
                                (dissoc toggle-titles indx)

                                :else
                                (assoc
                                  toggle-titles
                                  indx
                                  (if default-hidden?
                                    hidden-default-map
                                    header)))
                              (vals)
                              (sort-by :position)
                              (vec)))))})])
                header-lists))])
         (partition-all 3 header-list)))]]])

(defmethod grid/action :stockorder.planning/category-toggleheaders-ds
  [_ {:keys [state-atom path checkbox-path header-list]} _]
  (let [toggle-titles (yuc/index-by :position (cmn/curact state-atom path))]
    (into []
      (map
        (fn [[idx _]]
          (let [path-to-checkbox (rum/cursor state-atom (conj checkbox-path idx))]
            (when (get toggle-titles idx)
              (swap! path-to-checkbox assoc :value false)
              (swap! state-atom update-in path (dissoc toggle-titles idx)))))
        header-list))))

(defn checkbox-selections [state-atom checkbox-path checkbox-list]
  (into []
    (map
      (fn [[idx _]]
        (let [path-to-checkbox (rum/cursor state-atom (conj checkbox-path idx))]
          (swap! path-to-checkbox assoc :value true))))
    checkbox-list))

(defmethod grid/action :stockorder.planning/category-toggleheaders-sa
  [_ {:keys [state-atom path checkbox-path header-list]} _]
  (let [select-all-titles
        (->>
          (:column-defs-headers plan-items-table-config)
          (map
            #(if (:default-hidden? %)
               (assoc % :default-hidden? false)
               %)))]

    (checkbox-selections state-atom checkbox-path header-list)
    (swap! state-atom assoc-in path select-all-titles)))

(defmethod grid/action :stockorder.planning/category-toggleheaders-sd
  [_ {:keys [state-atom path checkbox-path header-list]} _]
  (let [original-titles (:column-defs plan-items-table-config)
        indexed-og-titles (yuc/index-by :position original-titles)]

    (grid/dispatch-action state-atom :stockorder.planning/category-toggleheaders-ds
      {:state-atom state-atom
       :path path
       :checkbox-path checkbox-path
       :header-list header-list})

    (checkbox-selections state-atom checkbox-path indexed-og-titles)
    (swap! state-atom assoc-in path original-titles)))

(rum/defc legend []
  (headings/heading "Status Legend:" {:type :h3 :size :small})
  [:ul.status-legend-list
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:ready :m])}]]
    [:span.status-legend-list-item__text
     "Ready"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:notready :m])}]]
    [:span.status-legend-list-item__text
     "Not Ready"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:notreadyitems :ready :m])}]]
    [:span.status-legend-list-item__text
     "Ready with Problem Items"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:notreadyitems :notready :m])}]]
    [:span.status-legend-list-item__text
     "Not Ready with Problem Items"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:ordered :m])}]]
    [:span.status-legend-list-item__text
     "Ordered"]]])

(rum/defcs plan-category < rum/reactive (rum/local {:legend? false} ::state) [s app-atom]
  (let [local-atom (::state s)
        local-state (rum/react local-atom)
        process-atom (cmn/process-cursor app-atom)
        level-two-categories-idx (cmn/curact process-atom :level-two-categories-idx)
        suppliers-by-id (yuc/index-by :id (cmn/curact process-atom [:suppliers]))
        action-atom (cmn/action-cursor app-atom)
        {:keys [supplierid cat1 cat2 planid]} (cmn/screen-params app-atom)
        decoded-cat1 (url/url-decode cat1)
        decoded-cat2 (url/url-decode cat2)
        category-ready? (get-in level-two-categories-idx [[decoded-cat1 decoded-cat2] :ready])
        header-list (yuc/index-by :position (:column-defs-headers plan-items-table-config))
        path [:datatables :stockorder/plan-items :config :column-defs]
        checked-path [:datatables :stockorder/plan-items :config :yc-input-checked-checkbox-map]]
    [:div
     (planning-css/plan-warnings)
     [:div
      {:class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid :grow-yes])}
       [:div.flex-grid-content
        (headings/heading
          [:a.update {:entity "supplierplan" :entityid "360329" :type "statusupdate" :status "Not Ready"}
           [:span
            {:class (yuc/bem :admin-status-dot [:ready :l])}]
           [:span.itemname
            (or
              decoded-cat2
              (get-in suppliers-by-id [(yuc/parseInt supplierid) :companyname]))]]
          {:type :h2
           :size :large
           :flush true})]]
      [:div
       {:class (yuc/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (buttons/button-web (if category-ready? "Rework Category" "Mark as Ready")
           {:on-click
            #(grid/dispatch-action app-atom :stockorder.planning/toggle-category-readiness
               {:category-ready? (not category-ready?)
                :cat-root-name decoded-cat1
                :cat-two-name decoded-cat2})
            :style :secondary
            :size :default})]]
       (when (yuc/presence decoded-cat1)
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           (buttons/button-web "Download SKU CSV"
             {:href
              (str "/api/planning/plan-csv?planid=" (:planid (cmn/screen-params app-atom))
                "&cat1=" (url/url-encode decoded-cat1)
                (when (yuc/presence decoded-cat2) (str "&cat2=" (url/url-encode decoded-cat2))))
              :target "_blank"
              :style :secondary
              :size :default})]])
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         ;; Not history.back: a category opened in a new tab has no entry to
         ;; go back to, and the button would silently do nothing.
         (buttons/button-web "Back"
           {:on-click #(urlstate/redirect app-atom "planning-new" "plan" {:planid planid})
            :style :secondary
            :size :default})]]
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (buttons/button-web "Try new layout"
           (merge
             (w.cmn/try-new-layout-props)
             {:style :light
              :size :default}))]]]]

     (category-overview-cards app-atom)

     (action-section
       {:title "Plan Selection"
        :items
        [(action-item action-atom [:accordian :foldout :brand]
           {:id "brands"
            :title "Brand Selection"

            :detail-body-fn (brand-cards app-atom)})

         (action-item action-atom [:accordian :foldout :product-type]
           {:id "product-type"
            :title "Product Type Selection"
            :default-foldout? true
            :detail-body-fn (product-type-cards app-atom)})

         (action-item action-atom [:accordian :foldout :legend]
           {:id "legend"
            :title "Legend"
            :detail-body-fn (legend)})

         (action-item action-atom [:accordian :foldout :items]
           {:id "items"
            :title "Suggested to order SKU's"
            :default-foldout? true
            :detail-body-fn
            (list
              [:div
               {:class (yuc/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
               [:div
                {:class (yuc/bem :flex-grid-block [:fluid])}
                [:div.flex-grid-content
                 (buttons/button-web "Select All"
                   {:type :button
                    :on-click
                    #(grid/dispatch-action action-atom :stockorder.planning/category-toggleheaders-sa
                       {:state-atom action-atom
                        :path path
                        :checkbox-path checked-path
                        :header-list header-list})
                    :style :secondary
                    :size :default})]]
               [:div
                {:class (yuc/bem :flex-grid-block [:fluid])}
                [:div.flex-grid-content
                 (buttons/button-web "Deselect All"
                   {:type :button
                    :on-click
                    #(grid/dispatch-action action-atom :stockorder.planning/category-toggleheaders-ds
                       {:state-atom action-atom
                        :path path
                        :checkbox-path checked-path
                        :header-list header-list})
                    :style :secondary
                    :size :default})]]
               [:div
                {:class (yuc/bem :flex-grid-block [:fluid])}
                [:div.flex-grid-content
                 (buttons/button-web "Select Default"
                   {:type :button
                    :on-click
                    #(grid/dispatch-action app-atom :stockorder.planning/category-toggleheaders-sd
                       {:state-atom action-atom
                        :path path
                        :checkbox-path checked-path
                        :header-list header-list})
                    :style :secondary
                    :size :default})]]
               [:div
                {:class (yuc/bem :flex-grid-block [:fluid])}
                [:div.flex-grid-content
                 (buttons/button-web "Toggle Red"
                   {:type :button
                    :on-click
                    #(grid/dispatch-action app-atom :stockorder.planning.planitems/unready-all-modal {})
                    :style :secondary
                    :size :default})]]
               [:div {:class (yuc/bem :flex-grid-block [:fluid :align-right])}
                [:div {:class "flex-grid-content"}
                 [:a
                  {:on-click #(swap! local-atom update :legend? not)
                   :class (yuc/bem :button [:default :raised :secondary :bordered])}
                  "Toggle Headers"]]]]

              (when (:legend? local-state)
                (hideable-data-table-columns action-atom
                  path
                  checked-path
                  header-list))

              [:div
               [:div.u-min-height-160
                (headings/heading "SKU's" {:type :h2 :size :medium})
                (datatables/table app-atom :stockorder/plan-items plan-items-table-fns)]])})

         (action-item action-atom [:selected-category-path :foldout]
           {:id "missing-skus"
            :title "Missing SKU's"
            :detail-body-fn (missing-items-table app-atom)})]})]))

(defmethod grid/action :stockorder.planning.planitems/unready-all-modal [app-atom config _]
  (grid/open-modal app-atom :grid/confirm
    {:title "Unready all items"
     :text
     (feedback/feedback :warning
       [:b "You are about to unready all items on this plan"]
       [:div
        [:p "There's no going back once you confirm!"]])
     :right-text "Unready items"
     :confirm-key :stockorder.planning.planitems/unready-all}))

(defmethod grid/action :stockorder.planning.planitems/unready-all [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        plan-id (cmn/curact process-atom [:planid])
        plan-items @(rum/cursor-in process-atom [:items])
        selected-items (filter-items-to-selection app-atom (vals plan-items))
        ready-items
        (->>
          selected-items
          (filter #(= (:status %) "Ready"))
          (map #(select-keys % [:itemid])))]

    (comms/send :stockorder.planning.planitems/unready-all
      {:stock-plan-id plan-id
       :stock-plan-items ready-items})))

(defmethod comms/receive :stockorder.planning.planitems/unready-all
  [app-atom {:keys [success msg]}]
  (toaster/open-toast app-atom :success msg {:closetime 4000}))

(defmethod grid/action :stockorder.planning/load-histories [app-atom config _]
  (comms/send :stockorder.planning/history {:vids (:vids config)}))

(defmethod grid/action :stockorder.planning/toggle-category-readiness
  [app-atom {:keys [category-ready? cat-root-name cat-two-name]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        user-id (cmn/curact app-atom [:user :refid])
        {:keys [id]} (cmn/curact process-atom :selected-plan)
        level-two-categories-idx (cmn/curact process-atom :level-two-categories-idx)
        {:keys [cat-root-id cat-two-id]} (get level-two-categories-idx [cat-root-name cat-two-name])]
    (comms/send :stockorder.planning.category-readiness/update
      {:plan-id id
       :planner-user-id user-id
       :cat-root-id cat-root-id
       :cat-two-id cat-two-id
       :ready? category-ready?
       :cat-root-name cat-root-name
       :cat-two-name cat-two-name})))

(defmethod comms/receive :stockorder.planning.category-readiness/update
  [app-atom {:keys [msg response success]}]
  (let [{:keys [msg msg-type]} msg
        {:keys [cat-root-name cat-two-name ready? planner-user-id]} response
        process-atom (cmn/process-cursor app-atom)]
    (cond
      success
      (do
        (swap! process-atom update-in [:level-two-categories-idx [cat-root-name cat-two-name]]
          assoc :ready ready? :planner-user-id (when ready? planner-user-id))
        (toaster/open-toast app-atom msg-type msg {:closetime 5000}))

      :else
      (toaster/open-toast app-atom :error msg {:closetime 5000}))))

(defmethod grid/action :stockorder.planning/toggle-split-order
  [_ {:keys [brandplan-id brand-name split-order?]} _]
  (comms/send :stockorder.planning.brand/split-order
    {:brandplan-id brandplan-id
     :brand-name brand-name
     :split-order? split-order?}))

(defmethod comms/receive :stockorder.planning.brand/split-order
  [app-atom {:keys [success brandplan-id split-order? msg]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (cond
      (not success)
      (toaster/open-toast app-atom :error (or msg "Could not change the split order.") {})

      :else
      (do
        (swap! process-atom update :items
          (fn [items]
            (reduce-kv
              (fn [acc vid item]
                (assoc acc vid
                  (if (= brandplan-id (:brandplanid item))
                    (assoc item :splitorder split-order?)
                    item)))
              {} items)))
        (toaster/open-toast app-atom :success msg {:closetime 3000})))))

(defmethod grid/action :stockorder.planning/toggle-commitment-order
  [_ {:keys [commitment-id include?]} _]
  (comms/send :stockorder.planning.commitment/update-status
    {:commitment-id commitment-id
     :include? include?}))

(defmethod comms/receive :stockorder.planning.commitment/update-status
  [app-atom {:keys [success commitment-id include? msg]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (cond
      (not success)
      (toaster/open-toast app-atom :error (or msg "Could not change the commitment.") {})

      :else
      (do
        (swap! process-atom update :plan-commitments
          (fn [commitments]
            (reduce-kv
              (fn [acc planitem-id items]
                (assoc acc planitem-id
                  (map
                    (fn [item]
                      (if (= commitment-id (:id item))
                        (assoc item :status (if include? "Ready" "Deleted"))
                        item))
                    items)))
              {} commitments)))
        (toaster/open-toast app-atom :success msg {:closetime 3000})))))

(defmethod comms/receive :stockorder.planning.category-readiness/broadcast
  [app-atom {:keys [cat-root-name cat-two-name ready? planner-user-id planner-name]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update-in [:level-two-categories-idx [cat-root-name cat-two-name]]
      assoc :ready ready? :planner-user-id (when ready? planner-user-id))
    (toaster/open-toast app-atom
      (if ready? :success :warning)
      (if ready?
        (str planner-name " marked " cat-two-name " as ready")
        (str planner-name " sent " cat-two-name " back for rework"))
      {:closetime 5000})))

(defmethod comms/receive :stockorder.planning/history
  [app-atom {:keys [forecast units stock sellabillity]}]
  (toaster/close-overlay app-atom :stockorder.planning/history)
  (let [action-atom (cmn/action-cursor app-atom)
        vid-histories (rum/cursor-in action-atom [:vid-histories])
        grouped-result
        (planning.cmn/nested-group-by [:vid :year :month]
          (concat
            forecast
            units
            stock
            sellabillity)
          (partial into {}))]
    (swap! vid-histories merge grouped-result)))

(defmethod grid/action :stockorder.planning/commitment-quantities [app-atom config _]
  (comms/send :stockorder.planning/-quantities {:vids (:vids config)}))

(defmethod comms/receive :stockorder.planning/commitment-quantities
  [app-atom {:keys [commitments]}]
  (toaster/close-overlay app-atom :stockorder.planning/commitment-quantities)
  (let [action-atom (cmn/action-cursor app-atom)
        commitment-quantities (rum/cursor-in action-atom [:commitment-quantities])
        grouped-result
        (planning.cmn/nested-group-by [:vid :year :month]
          commitments
          (partial into {}))]
    (swap! commitment-quantities merge grouped-result)))

(defmethod grid/action :stockorder.planning/load-future-quantities [app-atom config _]
  (comms/send :stockorder.planning/future-quantities {:vids (:vids config)}))

(defmethod comms/receive :stockorder.planning/future-quantities
  [app-atom {:keys [commitments indents]}]
  (let [action-atom (cmn/action-cursor app-atom)
        commitment-quantities-atom (rum/cursor-in action-atom [:commitment-quantities])
        grouped-commitments-result
        (planning.cmn/nested-group-by [:vid :year :month]
          commitments
          (partial into {}))

        indent-quantities-atom (rum/cursor-in action-atom [:indent-quantities])
        grouped-indents-result
        (planning.cmn/nested-group-by [:vid :year :month]
          indents
          (partial into {}))]

    (swap! commitment-quantities-atom merge grouped-commitments-result)
    (swap! indent-quantities-atom merge grouped-indents-result)))

(defmethod grid/action :stockorder.planning/load-missing-items [app-atom _ _]
  (let [{:keys [supplierid planid cat1 cat2]} (cmn/screen-params app-atom)]
    (comms/send :stockorder.planning/missing-items
      {:planid planid
       :supplierid supplierid
       :cats
       {:cat1 (url/url-decode cat1)
        :cat2 (url/url-decode cat2)}})))

(defmethod comms/receive :stockorder.planning/missing-items
  [app-atom {:keys [missing-items allocatedstore twentyeightdays neededstores planned]}]
  (let [action-atom (cmn/action-cursor app-atom)
        missing-atom (rum/cursor-in action-atom [:missing])
        merged-values
        (->>
          (concat allocatedstore twentyeightdays neededstores planned)
          (sort-by :variation_id)
          (partition-by :variation_id)
          (map (partial apply merge))
          (map
            #(assoc %
               :freestock_qty (or (:freestock_qty %) 0)
               :date_placed (or (:date_placed %) nil)
               :stockqty (or (:stockqty %) 0)
               :plannedqty (or (:plannedqty %) 0)
               :neededstores (or (:neededstores %) 0))))]
    (swap! missing-atom assoc
      :items (yuc/index-by :variation_id missing-items)
      :values merged-values)))

(defmethod comms/receive :stockorder.planning.planitem/receive-item
  [app-atom
   {{:keys [plan-items order-items suppliers allocated-stock store-plan-qtys]} :data
    {:keys [forecast units stock sellabillity]} :history}]
  (let [action-atom (cmn/action-cursor app-atom)
        vid-histories (rum/cursor-in action-atom [:vid-histories])
        new-plan-items
        (yuc/index-by
          :vid
          (map
            (fn [x]
              (assoc x
                :cats (vec (drop 3 (str/split (:fullname x) #":")))))
            plan-items))

        grouped-result
        (planning.cmn/nested-group-by [:vid :year :month]
          (concat
            forecast
            units
            stock
            sellabillity)
          (partial into {}))]
    (toaster/open-toast app-atom
      :success (str (count plan-items) " missing item(s) have been added")
      {:closetime 4000})
    (swap! vid-histories merge grouped-result)
    (swap! app-atom update :admin.planning-new
      (fn [plan]
        (->
          plan
          (update :items merge new-plan-items)
          (update :order-items concat order-items)
          (update :suppliers concat suppliers)
          (update :allocated-stock concat allocated-stock)
          (update :store-plan-qtys concat store-plan-qtys))))
    (update-mov-moq-atom app-atom)))

(defmethod flow/render-screen :admin.planning-new/category [app-atom _]
  (planning.cmn/with-loading-overlay app-atom (plan-category app-atom)))

(defmethod t/transition-open :admin.planning-new/category [app-atom _ params]
  (w.cmn/redirect-to-new-layout-if-needed! app-atom "planning" params))

(defmethod t/transition-after-open :admin.planning-new/category [app-atom _]
  (planning.cmn/validate-plan-items app-atom)
  (datatables/initiate app-atom suppliers-below-mov-moq-table-config {})
  (datatables/initiate app-atom out-of-stock-selected-items-table-config {})
  (datatables/initiate app-atom overstock-items-table-config {})
  (datatables/initiate app-atom plan-items-table-config {})
  (editor/initiate app-atom plan-items-editor-config))

(defmethod comms/receive :stockorder.planning/plan-create-list-update
  [app-atom
   {:keys [plans]}]
  (let [table-atom
        (datatables/table-cursor app-atom)

        idx-plans
        (yuc/index-by :planid plans)]

    (toaster/open-toast app-atom
      :success (str (count plans) (if (> (count plans) 1) " plans have been " " plan has been") " created.")
      {:closetime 4000})

    (swap! table-atom update :stockorder/oldplans
      (fn [datatable]
        (let [updated-list
              (merge (:data datatable) idx-plans)]

          (assoc datatable :data updated-list))))))

(defmethod comms/receive :stockorder.planning/plan-remove-list-update
  [app-atom {:keys [plans]}]
  (let [table-atom
        (datatables/table-cursor app-atom)

        idx-plans
        (yuc/index-by :id plans)]

    (toaster/open-toast app-atom
      :success (str (count plans) (if (> (count plans) 1) " plans have been " " plan has been") " removed.")
      {:closetime 4000})
    (swap! table-atom update :stockorder/oldplans
      (fn [datatable]
        (let [updated-rows
              (reduce
                (fn [acc [k old-plan]]
                  (let [plan
                        (get idx-plans k)]

                    ;this will need to be updated to use :ent/date-archived instead of :deleted once move to datomic happens
                    (if (nil? plan)
                      (assoc acc k old-plan)
                      (assoc acc k (assoc old-plan :deleted (:deleted plan))))))
                {} (:data datatable))]
          (->
            datatable
            (assoc :data updated-rows)
            (assoc-in [:config :selected-row] nil)))))))

(defmethod comms/receive :stockorder.planning/in-plan-remove-notification
  [app-atom]
  (toaster/open-toast app-atom
    :success (str "The plan you are currently viewing has been deleted.")
    {:closetime 4000}))
